/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import { selectIsMaintenanceMode } from '#selectors/ui/app.js';
import RequireMaintenanceOff from './RequireMaintenanceOff.jsx';

const mapStateToProps = state => ({
  isMaintenanceMode: selectIsMaintenanceMode(state),
});

export default connect(mapStateToProps)(RequireMaintenanceOff);
